export default __webpack_public_path__ + "22e249f9ccab315da5453120800c9260.svg";